import { useContext, useMemo } from 'react';
import Warning from '../../../icons/Alert.svg?react';
import { GlobalContext } from '../../../store/Store';

import '../SidePanel.css';
import { Provider } from '../../../generated/src/models';
import { formatDate } from '../../../mike-shared-helpers/date';

interface IProps {
  provider?: Provider;
  useInitialDate?: boolean;
}

const TemporalDataCoverage = (props: IProps) => {
  const { provider, useInitialDate } = props;

  const [globalState] = useContext(GlobalContext);

  const showWarning = useMemo(() => {
    const from = provider ? provider.from : null;
    const to = provider ? provider.to : null;
    if (from && to && globalState.mesh && globalState.mesh.extractionEndDate) {
      const startDate = useInitialDate
        ? globalState.mesh.extractionInitialDate
        : globalState.mesh.extractionStartDate;
      if (startDate) {
        const extractionStart = new Date(startDate);
        const extractionEnd = new Date(globalState.mesh?.extractionEndDate);
        const selectedPeriodIsCovered =
          extractionStart >= new Date(from) && extractionEnd <= new Date(to);
        return !selectedPeriodIsCovered;
      }
    }
    return false;
  }, [globalState && globalState.mesh, provider]);

  return provider ? (
    <div className="contentFlex dateFlex">
      <div className="panelItemContentText providerDate">
        {provider.from !== '' && provider.to !== ''
          ? `${formatDate(provider.from)} – ${formatDate(provider.to)}`
          : 'All dates available'}
      </div>
      {showWarning && (
        <div className="dateWarningIcon">
          <Warning           
            height={20}
            width={30}
            viewBox={"0 0 40 40"}
          />

       </div>
      )}
    </div>
  ) : null;
};

export default TemporalDataCoverage;
